import { render, staticRenderFns } from "./Print.vue?vue&type=template&id=36db8f97&scoped=true"
import script from "./Print.vue?vue&type=script&lang=js"
export * from "./Print.vue?vue&type=script&lang=js"
import style0 from "./Print.vue?vue&type=style&index=0&id=36db8f97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36db8f97",
  null
  
)

export default component.exports